import React, { FC } from 'react';
import { AiFillCloseSquare, AiFillInfoCircle } from 'react-icons/ai';
import { PiCheckSquareFill, PiWarningFill } from 'react-icons/pi';

interface Props {
    type?: 'success' | 'warning' | 'danger' | 'info';
    title?: string;
    className?: string;
    noIcon?: boolean;
}

const renderIcon = (type?: 'success' | 'warning' | 'danger' | 'info') => {
    switch (type) {
        case 'success' :
            return <PiCheckSquareFill className={"w-5 h-5"} />;
        case 'warning' :
            return <PiWarningFill className={"w-5 h-5"} />;
        case 'danger' :
            return <AiFillCloseSquare className={"w-5 h-5"} />;
        case 'info' :
            return <AiFillInfoCircle className={"w-5 h-5"} />;
    }
};

export const Badge: FC<Props> = ({ type, title, className, noIcon }) => {
    return (
        <div
            className={`flex items-center gap-2 text-sm font-medium justify-center h-8 px-2 rounded-[8px] ${type === 'success' ? 'text-positive-dark bg-badge-successBg' : type === 'warning' ? 'text-warning-default bg-badge-warningBg' : type === 'danger' ? 'text-negative-dark bg-badge-dangerBg' : type === 'info' ? 'text-primary-80 bg-badge-infoBg' : ''} ${className ? className : ''}`}>
            {!noIcon && renderIcon(type)}
            {title}
        </div>
    );
};